import { render } from "./ScrollFade.vue?vue&type=template&id=286ba1bb&scoped=true"
import script from "./ScrollFade.vue?vue&type=script&lang=js"
export * from "./ScrollFade.vue?vue&type=script&lang=js"

import "./ScrollFade.vue?vue&type=style&index=0&id=286ba1bb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286ba1bb"],['__file',"webpack-assets/vue/components/ScrollFade.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "286ba1bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('286ba1bb', __exports__)) {
    api.reload('286ba1bb', __exports__)
  }
  
  module.hot.accept("./ScrollFade.vue?vue&type=template&id=286ba1bb&scoped=true", () => {
    api.rerender('286ba1bb', render)
  })

}


export default __exports__